import {
  StyledTransactionList,
  StyledTransactionListHeader,
} from 'components/account-center/styled'
import React from 'react'
import { Transaction } from 'services'
import TransactionList from '../list-components/list'
import { StyledListWrapper } from '../style'
import TransactionItem from '../list-components/multi-list/multi-list-item'
import { HeadWrapper } from '../../../styled'

type Props = {
  transactionsPending: boolean
  transactionsFailed: boolean
  multiChainTransactions: Transaction[]
  singleChainTransactions: Transaction[]
}

/**
 * Presentation component for individual transactions list
 */
const PendingTransactionsListWrapper: React.FC<Props> = ({
  singleChainTransactions,
  multiChainTransactions,
}) => {
  if (singleChainTransactions.length === 0 && multiChainTransactions.length === 0) return null

  return (
    <StyledTransactionList>
      <HeadWrapper>
        <StyledTransactionListHeader>Pending transactions</StyledTransactionListHeader>
      </HeadWrapper>
      <StyledListWrapper>
        {multiChainTransactions.map((tx, index) => (
          <TransactionItem key={`${tx.hash}-${index}`} transaction={tx} />
        ))}
      </StyledListWrapper>
      {singleChainTransactions.length > 0 && (
        <TransactionList transactions={singleChainTransactions} pastTense={false} />
      )}
    </StyledTransactionList>
  )
}

export default PendingTransactionsListWrapper
